var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header_wrapper"},[_c('top-menu-new',{attrs:{"fetched-data":_vm.fetchedData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }